import { render, staticRenderFns } from "./closeAccountVerify.vue?vue&type=template&id=2212668c&scoped=true&"
import script from "./closeAccountVerify.vue?vue&type=script&lang=js&"
export * from "./closeAccountVerify.vue?vue&type=script&lang=js&"
import style0 from "./closeAccountVerify.vue?vue&type=style&index=0&id=2212668c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212668c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2212668c')) {
      api.createRecord('2212668c', component.options)
    } else {
      api.reload('2212668c', component.options)
    }
    module.hot.accept("./closeAccountVerify.vue?vue&type=template&id=2212668c&scoped=true&", function () {
      api.rerender('2212668c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/mtCloseAccount/closeAccountVerify.vue"
export default component.exports